<div class="col-12 invite-users">
  <div class="invite-users__block">
    <div class="title">
      <h2 class="sub-header">
        <span tabindex="0" >{{ !isBulkUsers ? state.pageHeading : state.bulkInvite }}</span>
      </h2>
    </div>

    <div class="row">
      <div class="col-10 desc">{{state.description}} <a [href]="state.externalLink.url" target="_blank"> {{state.externalLink.label}} </a></div>
      <div class="col-2 download">
        <kng-button class="button-download" [state]="downloadButtonState" (clicked)="downloadLocationTemplate()"
          tabindex="-1">
        </kng-button>
      </div>
    </div>
    <div class="banner_message--{{state.responseMessage}}"  [ngClass]="{'banner_message--display': service.displayFlag}">
      <div class="banner_message_title">{{state.messageTitle}}<span class="banner_message--cross-cta" (click)="crossCta()"></span></div>
      <div class="banner_message__description">{{state.messageDescription}} </div>
      <a class="banner_message--download-report" (click)="linkDownloadTemplate()">{{state.link.downloadButton}}</a>
    </div>

    <kng-upload-file #fileUploadComponent class="uploadList col-12" (fileValidationCheck)="fileValidationCheck($event)"
      (tryAgainEventEmitter)="uploadFileServerValidation($event)" (replaceFileEventEmitter)="replaceFileEventEmitter()"
      [state]="service.uploadFileState"></kng-upload-file>

    <div class="upload-limit-text">
      <br>
      <p>{{uploadLimit}}
        <span>{{uploadLimitText}}</span>
      </p>
    </div>

    <div class="action-footer" *ngIf="isBulkUsers; else bulkUsers">
      <div class="action-footer-container">
        <div class="send-invite-btn action-footer-sub-container">
          <kng-button class="cancel-btn" [state]="cancelButtonState" (clicked)="goBackToUserManagement()">
          </kng-button>
          <kng-button class="sendInvite-btn" [state]="sendInviteButtonState" (clicked)="submitLocationTemplate()">
          </kng-button>
        </div>
      </div>
    </div>
    <ng-template #bulkUsers>
      <div class=" download-submit" >
        <kng-button class="submit button-download" [state]="submitButtonState" (clicked)="submitLocationTemplate()"
          tabindex="-1">
        </kng-button>
      </div>
    </ng-template>

  </div>
</div>